module.exports = __webpack_public_path__ + "static/scale-model-of-john-deere-pavilion-in-davenport-iowa-895a6888f852103608219c785a60ff3b.png";